export default {
  fonts: {
    typeface: {
      starJedi: "Starjedi",
      starjhol: "Starjhol",
      starjout: "Starjout",
      tradeGothic: "TradeGothic",
      timesNewRoman: "Times New Roman",
      arial: "Arial",
      verdana: "Verdana",
      tahoma: "Tahoma",
      georgia: "Georgia",
      courierNew: "Courier New",
      monospace: "ui-monospace, SFMono-Regular, Menlo, Consolas, \"Courier New\", monospace",
    },
    weight: {
      light: "300",
      standard: "400",
      dark: "700",
    },
    decorations: {
      none: "none",
      underline: "underline",
    },
    style: {
      none: "none",
      italic: "italic",
    },
  },
  sizes: {
    lineHeight: {
      standard: "1.5",
      relaxed: "1.6",
    },
    measure: {
      prose: "72ch",
    },
    variants: {
      none: "0",
      hairline: "1px",
      extraThin: "2px",
      veryThin: "6px",
      thin: "4px",
      extraSmall: "8px",
      verySmall: "12px",
      standard: "14px",
      regular: "16px",
      large: "20px",
      extraLarge: "24px",
      huge: "32px",
      extraHuge: "36px",
      veryHuge: "40px",
      gigantic: "48px",
      extraGigantic: "64px",
      veryGigantic: "88px",
    },
  },
  colors: {
    transparent: {
      100: "transparent",
    },
    yellow: {
      100: "#ffffe5",
      200: "#ffffcc",
      300: "#ffff99",
      400: "#ffff66",
      500: "#ffff33",
      600: "#ffff00",
      700: "#cccc00",
      800: "#999900",
      900: "#666600",
    },
    starfield: {
      100: "#1a1a1a",
      200: "#141414",
      300: "#0d0d0d",
      400: "#080808",
      500: "#000000",
      shadow: "rgba(0, 0, 0, 0.8)",
    },
    grey: {
      100: "#ffffff",
      200: "#f5f5f5",
      300: "#dddddd",
      400: "#bbbbbb",
      500: "#888888",
      600: "#666666",
      700: "#444444",
      800: "#2a2a2a",
      900: "#1a1a1a",
    },
    red: {
      500: "#ff5555",
      600: "#ff2222",
      700: "#cc0000",
    },
    green: {
      500: "#22ff55",
      600: "#00cc44",
    },
    blue: {
      100: "#e5f2ff",
      200: "#cce5ff",
      400: "#66b3ff",
      600: "#007bff",
      700: "#0066cc",
      800: "#004c99",
      900: "#003366",
    },
    orange: {
      400: "#ffb366",
      500: "#ff9933",
      600: "#ff8000",
      700: "#cc6600",
    },
    purple: {
      100: "#f2e5ff",
      200: "#e5ccff",
      300: "#cc99ff",
      400: "#b366ff",
      500: "#7a7ad6",
      600: "#5a5ac8",
      700: "#4949b0",
      800: "#4c0099",
    },
  },
};
